import Vue from 'vue'
import axios from 'axios'
import {
  Toast
} from 'vant'
import {
  Dialog
} from 'vant'
import '../../node_modules/vant/lib/toast/style'
import router from '../router/index'
Vue.use(Toast)
Vue.use(Dialog)

const config = {
  //baseURL: 'http://192.168.10.135:7866/',
  //  baseURL: 'http://192.168.50.110:5001/', //http请求baseurl
  baseURL: 'https://bosapi.liudubole.com:4443/', //http请求baseurl
  timeout: 100 * 1000, // 请求超时时间设置
}

// 创建请求实例
const _axios = axios.create(config)

/**
 * @param {string} url
 * @param {object} data 结构数据
 * @param {object} params 参数
 */
export function post(url, data = {}, params = {}) {
  const user = JSON.parse(localStorage.getItem('BosUser'))
  _axios.defaults.headers.common['Authorization'] = ''
  if (user != undefined && user.expireTime > Date.now() && url != "/Account/Login") {
    _axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
  }
  return _axios({
    method: 'post',
    url,
    data,
    params,
  }).then(
    (response) => {
      return response.data
    },
    (error) => {
      if (url != "/Static/GetCustVisStatic" && url != "/Static/CheckStaticPassWord"
      && url != "/StaticMain/CheckStaticPassWord") {
        router.push("/login")
        if (user == undefined) {
          Toast('用户信息失效:code-01')
        } else if (user.expireTime <= Date.now()) {
          Toast('用户信息过期:code-02')
        } else {
          Toast({ message: '测试信息post'+localStorage.getItem('BosUser')+'##user.expireTime：'+user.expireTime+'Date.now():'+Date.now()+'##url'+url+'##'+error.message});
          Toast('出错了！:' + error.message)
        }
      } else {
        Toast('网络异常请稍后在进行操作')
      }
    }
  )
}



/**
 * @param {string} url
 * @param {object} params
 */
export function get(url, params = {}) {
  const user = JSON.parse(localStorage.getItem('BosUser'))
  _axios.defaults.headers.common['Authorization'] = ''
  if (user != undefined && user.expireTime > Date.now() && url != "/Account/Login") {
    _axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
  }
  return _axios({
    method: 'get',
    url,
    params,
  }).then(
    (response) => {
      return response.data
    },
    (error) => {
      console.log(error)
      if (url != "/Static/GetCustVisStatic" && url != "/Static/CheckStaticPassWord") {
        router.push("/login")
        if (user == undefined) {
          Toast('用户信息失效:code-01')
        } else if (user.expireTime <= Date.now()) {
          Toast('用户信息过期:code-02')
        } else {
          //Toast({ message: '测试信息get'+localStorage.getItem('BosUser')+'##user.expireTime：'+user.expireTime+'Date.now():'+Date.now()+'##url'+url+'##'+error.message});
          //Toast('出错了！:' + error.message)
        }
      } else {
        Toast('网络异常请稍后在进行操作')
      }
    }
  )
}

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
export function put(url, data = {}, params = {}) {
  const user = JSON.parse(localStorage.getItem('BosUser'))
  _axios.defaults.headers.common['Authorization'] = ''
  if (user != undefined && user.expireTime > Date.now() && url != "/Account/Login") {
    _axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
  }
  return _axios({
    method: 'put',
    url,
    params,
    data,
  }).then(
    (response) => {
      return response.data
    },
    (error) => {
      console.log(error)
      if (url != "/Static/GetCustVisStatic" && url != "/Static/CheckStaticPassWord") {
        //router.push("/login")
        if (user == undefined) {
          Toast('用户信息失效:code-01')
        } else if (user.expireTime <= Date.now()) {
          Toast('用户信息过期:code-02')
        } else {
          //Toast({ message: '测试信息put'+localStorage.getItem('BosUser')+'##user.expireTime：'+user.expireTime+'Date.now():'+Date.now()+'##url'+url+'##'+error.message});
          //Toast('出错了！:' + error.message)
        }
      } else {
        Toast('网络异常请稍后在进行操作')
      }
    }
  )
}

/**
 * @param {string} url
 * @param {object} params
 */
export function _delete(url, params = {}) {
  const user = JSON.parse(localStorage.getItem('BosUser'))
  _axios.defaults.headers.common['Authorization'] = ''
  if (user != undefined && user.expireTime > Date.now() && url != "/Account/Login") {
    _axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token
  }
  return _axios({
    method: 'delete',
    url,
    params,
  }).then(
    (response) => {
      return response.data
    },
    (error) => {
      console.log(error)
      if (url != "/Static/GetCustVisStatic" && url != "/Static/CheckStaticPassWord") {
        router.push("/login")
        if (user == undefined) {
          Toast('用户信息失效:code-01')
        } else if (user.expireTime <= Date.now()) {
          Toast('用户信息过期:code-02')
        } else {
          //Toast({ message: '测试信息del'+localStorage.getItem('BosUser')+'##user.expireTime：'+user.expireTime+'Date.now():'+Date.now()+'##url'+url+'##'+error.message});
          //Toast('出错了！:' + error.message)
        }
      } else {
        Toast('网络异常请稍后在进行操作')
      }
    }
  )
}

export default _axios